import { render } from "./FeaturePreviewBox.vue?vue&type=template&id=e1355da0"
import script from "./FeaturePreviewBox.vue?vue&type=script&lang=js"
export * from "./FeaturePreviewBox.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "e1355da0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e1355da0', script)) {
    api.reload('e1355da0', script)
  }
  
  module.hot.accept("./FeaturePreviewBox.vue?vue&type=template&id=e1355da0", () => {
    api.rerender('e1355da0', render)
  })

}

script.__file = "resources/js/Pages/Station/Partials/Features/FeaturePreviewBox.vue"

export default script